/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyTemperature } from "./CompanyTemperature";
import {
  CompanyTemperatureFromJSON,
  CompanyTemperatureFromJSONTyped,
  CompanyTemperatureToJSON,
  CompanyTemperatureToJSONTyped,
} from "./CompanyTemperature";
import type { ControlsLtlFreight } from "./ControlsLtlFreight";
import {
  ControlsLtlFreightFromJSON,
  ControlsLtlFreightFromJSONTyped,
  ControlsLtlFreightToJSON,
  ControlsLtlFreightToJSONTyped,
} from "./ControlsLtlFreight";

/**
 *
 * @export
 * @interface ListSalesContactsRow
 */
export interface ListSalesContactsRow {
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  salesContactId: string;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  companyName: string;
  /**
   *
   * @type {CompanyTemperature}
   * @memberof ListSalesContactsRow
   */
  temperature?: CompanyTemperature | null;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {ControlsLtlFreight}
   * @memberof ListSalesContactsRow
   */
  controlsLtlFreight: ControlsLtlFreight;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  email?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  phone?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  mobilePhone?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  description?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof ListSalesContactsRow
   */
  inactive: boolean;
  /**
   *
   * @type {string}
   * @memberof ListSalesContactsRow
   */
  notes: string;
}

/**
 * Check if a given object implements the ListSalesContactsRow interface.
 */
export function instanceOfListSalesContactsRow(
  value: object,
): value is ListSalesContactsRow {
  if (!("salesContactId" in value) || value["salesContactId"] === undefined)
    return false;
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("companyName" in value) || value["companyName"] === undefined)
    return false;
  if (
    !("controlsLtlFreight" in value) ||
    value["controlsLtlFreight"] === undefined
  )
    return false;
  if (!("inactive" in value) || value["inactive"] === undefined) return false;
  if (!("notes" in value) || value["notes"] === undefined) return false;
  return true;
}

export function ListSalesContactsRowFromJSON(json: any): ListSalesContactsRow {
  return ListSalesContactsRowFromJSONTyped(json, false);
}

export function ListSalesContactsRowFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListSalesContactsRow {
  if (json == null) {
    return json;
  }
  return {
    salesContactId: json["salesContactId"],
    companyId: json["companyId"],
    companyName: json["companyName"],
    temperature:
      json["temperature"] == null
        ? undefined
        : CompanyTemperatureFromJSON(json["temperature"]),
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    controlsLtlFreight: ControlsLtlFreightFromJSON(json["controlsLtlFreight"]),
    name: json["name"] == null ? undefined : json["name"],
    email: json["email"] == null ? undefined : json["email"],
    phone: json["phone"] == null ? undefined : json["phone"],
    mobilePhone: json["mobilePhone"] == null ? undefined : json["mobilePhone"],
    description: json["description"] == null ? undefined : json["description"],
    inactive: json["inactive"],
    notes: json["notes"],
  };
}

export function ListSalesContactsRowToJSON(json: any): ListSalesContactsRow {
  return ListSalesContactsRowToJSONTyped(json, false);
}

export function ListSalesContactsRowToJSONTyped(
  value?: ListSalesContactsRow | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    salesContactId: value["salesContactId"],
    companyId: value["companyId"],
    companyName: value["companyName"],
    temperature: CompanyTemperatureToJSON(value["temperature"]),
    shipmentFrequency: value["shipmentFrequency"],
    controlsLtlFreight: ControlsLtlFreightToJSON(value["controlsLtlFreight"]),
    name: value["name"],
    email: value["email"],
    phone: value["phone"],
    mobilePhone: value["mobilePhone"],
    description: value["description"],
    inactive: value["inactive"],
    notes: value["notes"],
  };
}
